import questionnaire from './components/questionnaire';

export default {
    questionnaire
};
